<div class="pie-chart">
  <canvas
    baseChart
    [data]="pieChartData"
    [options]="pieChartOptions"
    [type]="chartType"
    []="'70%'"
    *ngIf="pieChartData"
    (chartClick)="chartClicked($event)"
  >
  </canvas>

  <app-pie-chart-legend
    [dataset]="dataset"
    [colors]="colors">
  </app-pie-chart-legend>
</div>
